import React from "react";
import VehicleOrders from "./VehicleOrders";

export default function VehicleCompletedOrders() {
  return <VehicleOrders type="completed" />;
}
